import React from 'react';
import { Link } from 'react-router-dom';
import './DishList.css';
import DishListIconMark from '../images/dishlist-icon-mark.png';
import DishListWeeklyPlanner from '../images/screenshots/DishListWeeklyPlanner.png';
import DishListMealPreferences from '../images/screenshots/DishListMealPreferences.png';
import DishListMealCalendar from '../images/screenshots/DishListMealCalendar.png';

function DishList() {
  return (
    <div className="dishlist">
      <section className="dishlist-header">
        <div className="page-app-icon dishlist-page-icon">
          <img src={DishListIconMark} alt="DishList app icon" />
        </div>
        <h1>DishList</h1>
        <p>Family meal planning made simple and fair</p>
      </section>

      <section className="app-showcase">
        <div className="content-wrapper">
          <div className="app-detail">
            <div className="app-info">
              <div className="app-description">
                <p>
                  DishList takes the stress out of weekly meal planning by giving every family member 
                  a voice in what's for dinner. No more daily battles over food choices or one parent 
                  bearing the entire burden of meal planning. DishList helps families create a weekly 
                  dinner schedule that makes everyone happy.
                </p>
                
                <h3>Key Features</h3>
                <ul>
                  <li><strong>Family Voting:</strong> Each family member can vote for their favorite meals from your custom list</li>
                  <li><strong>Fair Rotation:</strong> Smart scheduling ensures everyone gets their turn to pick</li>
                  <li><strong>Custom Food Lists:</strong> Add family favorites, restaurants, recipes, and dietary preferences</li>
                  <li><strong>Weekly Planning:</strong> Generate balanced weekly meal plans with variety and nutrition in mind</li>
                  <li><strong>Shopping Lists:</strong> Automatically generate grocery lists based on your meal plan</li>
                  <li><strong>Dietary Restrictions:</strong> Support for allergies, vegetarian, vegan, and other dietary needs</li>
                </ul>

                <h3>Why DishList?</h3>
                <p>
                  We built DishList because meal planning shouldn't be a daily struggle. Every parent knows 
                  the frustration of spending time planning meals only to hear "I don't want that!" 
                  DishList democratizes dinner decisions, reduces picky eater pushback, and brings families 
                  together around food choices that work for everyone.
                </p>

                <h3>Perfect For</h3>
                <ul>
                  <li>👨‍👩‍👧‍👦 <strong>Busy Families:</strong> Streamline meal planning and reduce daily stress</li>
                  <li>🍽️ <strong>Picky Eaters:</strong> Give everyone a voice in meal decisions</li>
                  <li>📅 <strong>Organized Parents:</strong> Plan ahead and stay on top of meal prep</li>
                  <li>🛒 <strong>Smart Shoppers:</strong> Never forget ingredients with auto-generated lists</li>
                </ul>

                <h3>How It Works</h3>
                <div className="how-it-works">
                  <div className="step">
                    <div className="step-number">1</div>
                    <div className="step-content">
                      <h4>Build Your Food List</h4>
                      <p>Add family favorites, restaurants, recipes, and meal ideas to your master list</p>
                    </div>
                  </div>
                  <div className="step">
                    <div className="step-number">2</div>
                    <div className="step-content">
                      <h4>Family Votes</h4>
                      <p>Each family member votes for their preferred meals for the upcoming week</p>
                    </div>
                  </div>
                  <div className="step">
                    <div className="step-number">3</div>
                    <div className="step-content">
                      <h4>Smart Scheduling</h4>
                      <p>DishList creates a fair weekly plan ensuring everyone gets their favorites</p>
                    </div>
                  </div>
                  <div className="step">
                    <div className="step-number">4</div>
                    <div className="step-content">
                      <h4>Shop & Cook</h4>
                      <p>Get your auto-generated shopping list and enjoy stress-free meal times</p>
                    </div>
                  </div>
                </div>

                <div className="app-store-section">
                  <p className="availability">Coming Soon to the App Store</p>
                  <div className="coming-soon-badge">
                    <span className="badge-text">Available Soon</span>
                  </div>
                  <p className="notify-text">Be the first to know when DishList launches!</p>
                </div>

                <div className="food-support-notice">
                  <h3>Food, Safety &amp; Wellbeing</h3>
                  <p>
                    Meal planning should support your family, never shame anyone or replace a food-allergy safety plan.
                    Help is available for difficult eating patterns, overeating, and food-allergy concerns.
                  </p>
                  <Link to="/food-support" className="food-support-link">
                    View Food Support &amp; Allergy Resources
                  </Link>
                </div>
              </div>
            </div>

            <div className="app-screenshots">
              <h3>Screenshots</h3>
              <div className="screenshots-grid">
                <div className="screenshot-item">
                  <img src={DishListMealPreferences} alt="DishList persistent meal preferences" />
                  <p>Meal Preferences</p>
                </div>
                <div className="screenshot-item">
                  <img src={DishListWeeklyPlanner} alt="DishList weekly meal planner" />
                  <p>Weekly Planning</p>
                </div>
                <div className="screenshot-item">
                  <img src={DishListMealCalendar} alt="DishList meal plan calendar" />
                  <p>Meal Calendar</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default DishList;
